module.exports = __webpack_public_path__ + "img/logo_crew_horizontal_white_bg.4503e3f6.svg";